import { type CanvasTokenNode } from '../slices/createCanvasTokenNodeSlice';

/** Find all node entries whose group.id matches the given id. */
export function findGroupMembers(nodes: Record<string, CanvasTokenNode>, groupId: string): [string, CanvasTokenNode][] {
  return Object.entries(nodes).filter(([, node]) => node.group?.id === groupId);
}
